import {localize} from '@src/utils';

export default {
  meta() {

    let title = '';
    let description = '';

    // From Item.

    if (this.item) {

      if (!title)
        title = this.item.metaTitle
          || localize(this.item.title)
          || title;

      if (!description)
        description = this.item.metaDescription
          || localize(this.item.annotation)
          || description;
    }

    // From Route.

    if (this.$route.meta) {

      if (!title)
        title = this.$route.meta.title
          || title;

      if (!description)
        description = this.$route.meta.description
          || description;
    }

    return {
      title,
      meta: [
        {name: 'description', content: description},
      ],
    };
  },
};
